import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import AI from '../Assets/AI-Powered.png';
import Why from '../Assets/WhyAIPharmaExchange.png';
import { Link } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
function Home() {
  const whyitems = [
    { id: 1, text: "AI-Driven Pharma Staffing & Solutions", completed: true },
    { id: 2, text: "Global Talent Pool", completed: true },
    { id: 3, text: "Cutting-Edge Research & Development Support", completed: true },
    { id: 4, text: "Compliance & Regulatory Expertise", completed: true },
  ];

  const AIDriven = [
    { id: 1, text: "Clinical & Research Staffing: Hire the best scientists,researchers, and medical professionals.", completed: true },
    { id: 2, text: "Regulatory & Compliance Experts Ensure compliance with industry standards.", completed: true },
    { id: 3, text: "Data Science & AI Talent: Bridge the gap between AI and pharma.", completed: true },

  ];

  const AIPowered = [
    { id: 1, text: "Drug Discovery Acceleration", completed: true },
    { id: 2, text: "Predictive Analytics for Clinical Trials", completed: true },
    { id: 3, text: "Automated Pharma Compliance & Reporting", completed: true },

  ];

  const Pharma = [
    { id: 1, text: "Contract Staffing & Permanent Hiring", completed: true },
    { id: 2, text: "R&D Outsourcing Services", completed: true },
    { id: 3, text: "AI-Integrated Healthcare Solutions", completed: true },

  ];
  return (
    <Container fluid className='m-0 p-0' >

      <div style={{ backgroundColor: '#025EA9' }} className='m-0 p-4 header-bg'>
        <Container>
          <Row >
            <Col sm={6}  >

              <img src={AI} alt='Employment Exchange' className='img-fluid mt-4 mb-4' />
            </Col>
            <Col sm={6} className='pt-5 mt-5'>
              <h2 class="text-white" style={{ fontSize: '2.6rem' }}>Revolutionizing Pharma with <br />
                AI-Powered Talent & Solutions</h2>
              <p class="text-white" style={{ fontSize: '1.4rem' }}>Connecting pharmaceutical companies with AI-driven <br />
                recruitment, research, and development services.</p>
              <div class="d-grid gap-2 d-md-flex mt-4">
                <Card.Link className='rounded-button text-decoration-none'>Get Started <i class="bi bi-arrow-right"></i></Card.Link>
                <Card.Link className='simple-button text-white text-decoration-none'>Learn More <i class="bi bi-arrow-right"></i></Card.Link>
              </div>

            </Col>

          </Row>
        </Container>

      </div>

      <Container>

        <div class="row">

          <div class="col-lg-6 col-md-6 col-12 pt-4">
            <h2 className='fw-bold' style={{ color: '#025EA9' }}>Why AI <span style={{ color: '#E11D38' }}>Pharma</span> Exchange</h2>
            <div className="item-list mt-4">
              <ul className='m-0 p-0'>
                {whyitems.map(item => (
                  <li
                    key={item.id}
                    className={item.completed ? 'completed' : 'incomplete'}
                  >
                    {item.completed && <i class="bi bi-check2-square tick-icon"></i>}
                    <span className="item-text"> {item.text}</span>
                  </li>
                ))}
              </ul>
            </div>

          </div>
          <div class="col-lg-4 col-md-5 col-12 mx-auto">  <img src={Why} alt='Employment Exchange' className='img-fluid mt-4 mb-4' /> </div>
        </div>


      </Container>


      <div style={{ backgroundColor: '#EBF2F7' }} className='pt-5 pb-5'>
        <Container>
          <h2 className='fw-bold text-center' style={{ color: '#025EA9' }}>Key Offerings</h2>
          <Row className="g-3 mt-2  "> {/* 'g-3' adds spacing between columns */}
            <Col style={{ backgroundColor: '#EBF2F7', borderLeft: 'solid 8px #F37010', fontSize: '14px' }} xs={12} sm={4}> {/* xs={12} makes it full width on small screens */}
              <h3 style={{ paddingLeft: '20px' }}>AI-Driven Pharma Recruitment</h3>
              <div className="item-list mt-4">
                <ul className='m-0 p-0'>
                  {AIDriven.map(item => (
                    <li style={{ backgroundColor: 'transparent' }}
                      key={item.id}
                      className={item.completed ? 'completed' : 'incomplete'}
                    >
                      {item.completed && <i class="bi bi-check2-square tick-icon"></i>}
                      <span className="item-text"> {item.text}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </Col>
            <Col style={{ backgroundColor: '#EBF2F7', borderLeft: 'solid 8px #F37010', fontSize: '14px' }} xs={12} sm={4}>
              <h3 style={{ paddingLeft: '20px' }}>AI-Powered Pharma Solutions</h3>
              <div className="item-list mt-4">
                <ul className='m-0 p-0'>
                  {AIPowered.map(item => (
                    <li style={{ backgroundColor: 'transparent' }}
                      key={item.id}
                      className={item.completed ? 'completed' : 'incomplete'}
                    >
                      {item.completed && <i class="bi bi-check2-square tick-icon"></i>}
                      <span className="item-text"> {item.text}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </Col>
            <Col style={{ backgroundColor: '#EBF2F7', borderLeft: 'solid 8px #F37010', fontSize: '14px' }} xs={12} sm={4}>
              <h3 style={{ paddingLeft: '20px' }}>Pharma-Focused Business Solutions</h3>
              <div className="item-list mt-4">
                <ul className='m-0 p-0'>
                  {Pharma.map(item => (
                    <li style={{ backgroundColor: 'transparent' }}
                      key={item.id}
                      className={item.completed ? 'completed' : 'incomplete'}
                    >
                      {item.completed && <i class="bi bi-check2-square tick-icon"></i>}
                      <span className="item-text"> {item.text}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </Col>
          </Row>

        </Container>
      </div>


      <div style={{ backgroundColor: '#025EA9' }} className='pt-5 pb-5 howitsworks-header-bg'>
        <Container>
          <h2 className='fw-bold text-center text-white mt-4'>How It Works</h2>

          <div class="steps pb-5">
            <div id="progress"></div>
            <div class="step-item">
              <button class="step-button text-center" type="button" data-toggle="collapse"
                data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                1
              </button>
              <div class="step-title">
                Sign Up & Create <br />Profile
              </div>
            </div>
            <div class="step-item">
              <button class="step-button text-center collapsed" type="button" data-toggle="collapse"
                data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                2
              </button>
              <div class="step-title">
                Post Jobs & <br />Requirements
              </div>
            </div>
            <div class="step-item">
              <button class="step-button text-center collapsed" type="button" data-toggle="collapse"
                data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                3
              </button>
              <div class="step-title">
                Match with AI-Powered <br />Recommendations
              </div>
            </div>

            <div class="step-item">
              <button class="step-button text-center collapsed" type="button" data-toggle="collapse"
                data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                4
              </button>
              <div class="step-title">
                Onboard Top-Tier <br />Pharma Talent
              </div>
            </div>


            <div class="step-item">
              <button class="step-button text-center collapsed" type="button" data-toggle="collapse"
                data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                5
              </button>
              <div class="step-title">
                Scale Your Business <br />with AI Support
              </div>
            </div>
          </div>
        </Container>
      </div>
    </Container>

  );


}

export default Home